import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthContext";

// Route data + AI through the backend proxy. Prefer the Cloudflare-injected
// VITE_BACKEND_URL, but hardcode the production backend as a fallback so the app
// stays reachable even if the env var fails to bake into the bundle.
const backendUrl =
  import.meta.env.VITE_BACKEND_URL ||
  "https://searchlightbackend-production.up.railway.app";
window.QUANT_SIGNAL_BACKEND = backendUrl;

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
